import React, { useEffect, useMemo, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from "./AdminNavbar.module.css";
import { useAuth } from "../../app/context/AuthContext";

function safeText(value, fallback = "") {
  const text = String(value ?? "").trim();
  return text || fallback;
}

export default function AdminNavbar({ pageTitle = "Admin Dashboard" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const avatarUrl = useMemo(() => {
    return (
      safeText(user?.image) ||
      safeText(user?.avatarUrl) ||
      safeText(user?.profilePictureUrl) ||
      ""
    );
  }, [user]);

  const adminLinks = useMemo(
    () => [
      { label: "Dashboard", path: "/admin" },
      { label: "Users", path: "/admin/users" },
      { label: "Profiles", path: "/admin/profiles" },
      { label: "Subscription Plans", path: "/admin/subscription-plans" },
    ],
    []
  );

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return;

    const handleMouseDown = (event) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  const handleLogout = async () => {
    try {
      await logout();
    } finally {
      navigate("/login");
    }
  };

  return (
    <header className={styles.AdminNavbarRoot_akp91}>
      <div className={styles.AdminNavbarLeft_akp91}>
        <div
          className={styles.AdminBrandWrap_akp91}
          onClick={() => navigate("/admin")}
        >
          <div className={styles.AdminBrandLogo_akp91}>DS</div>
          <div className={styles.AdminBrandText_akp91}>
            <div className={styles.AdminBrandName_akp91}>DulhaSarkari Admin</div>
            <div className={styles.AdminBrandTag_akp91}>{pageTitle}</div>
          </div>
        </div>
      </div>

      <nav className={styles.AdminTopLinks_akp91} aria-label="Admin navigation">
        {adminLinks.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/admin"}
            className={({ isActive }) =>
              `${styles.AdminTopLink_akp91} ${
                isActive ? styles.AdminTopLinkActive_akp91 : ""
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className={styles.AdminNavbarRight_akp91} ref={menuRef}>
        <div className={styles.AdminWelcomeText_akp91}>
          <span className={styles.AdminWelcomeLabel_akp91}>Welcome,</span>
          <strong className={styles.AdminWelcomeName_akp91}>
            {safeText(user?.name, "Admin")}
          </strong>
        </div>

        <button
          type="button"
          className={styles.AdminUserChip_akp91}
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="Admin user menu"
        >
          {avatarUrl ? (
            <img
              src={avatarUrl}
              alt="admin avatar"
              className={styles.AdminUserAvatarImg_akp91}
            />
          ) : (
            <span className={styles.AdminUserAvatarFallback_akp91}>
              {safeText(user?.name, "A").charAt(0).toUpperCase()}
            </span>
          )}
        </button>

        {menuOpen && (
          <div className={styles.AdminMenuPanel_akp91}>
            <div className={styles.AdminMenuProfile_akp91}>
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt="admin"
                  className={styles.AdminMenuAvatarImg_akp91}
                />
              ) : (
                <div className={styles.AdminMenuAvatarFallback_akp91}>
                  {safeText(user?.name, "A").charAt(0).toUpperCase()}
                </div>
              )}

              <div className={styles.AdminMenuName_akp91}>
                {safeText(user?.name, "Admin")}
              </div>
              <div className={styles.AdminMenuEmail_akp91}>
                {safeText(user?.email, "")}
              </div>
              <div className={styles.AdminMenuRole_akp91}>
                Role: {safeText(user?.role, "admin")}
              </div>
            </div>

            <div className={styles.AdminMenuActions_akp91}>
              <button
                type="button"
                className={styles.AdminMenuBtn_akp91}
                onClick={() => navigate("/")}
              >
                🏠 Home
              </button>

              <button
                type="button"
                className={styles.AdminMenuDangerBtn_akp91}
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}








// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { NavLink, useLocation, useNavigate } from "react-router-dom";
// import styles from "./AdminNavbar.module.css";
// import { useAuth } from "../../app/context/AuthContext";

// function safeText(value, fallback = "") {
//   const text = String(value ?? "").trim();
//   return text || fallback;
// }

// function AdminNavBadge({ count }) {
//   if (!count) return null;
//   return (
//     <span className={styles.AdminNavBadge_akp91}>
//       {count > 99 ? "99+" : count}
//     </span>
//   );
// }

// export default function AdminNavbar({
//   sidebarOpen,
//   setSidebarOpen,
//   pageTitle = "Admin Dashboard",
// }) {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { user, logout } = useAuth();

//   const [menuOpen, setMenuOpen] = useState(false);
//   const menuRef = useRef(null);

//   const avatarUrl = useMemo(() => {
//     return (
//       safeText(user?.image) ||
//       safeText(user?.avatarUrl) ||
//       safeText(user?.profilePictureUrl) ||
//       ""
//     );
//   }, [user]);

//   const adminLinks = useMemo(
//     () => [
//       { label: "Dashboard", path: "/admin" },
//       { label: "Users", path: "/admin/users" },
//       { label: "Profiles", path: "/admin/profiles" },
//       { label: "Connections", path: "/admin/connections" },
//     ],
//     []
//   );

//   useEffect(() => {
//     setMenuOpen(false);
//   }, [location.pathname]);

//   useEffect(() => {
//     if (!menuOpen) return;

//     const handleMouseDown = (event) => {
//       if (!menuRef.current) return;
//       if (!menuRef.current.contains(event.target)) {
//         setMenuOpen(false);
//       }
//     };

//     const handleKeyDown = (event) => {
//       if (event.key === "Escape") {
//         setMenuOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleMouseDown);
//     document.addEventListener("keydown", handleKeyDown);

//     return () => {
//       document.removeEventListener("mousedown", handleMouseDown);
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [menuOpen]);

//   const handleLogout = async () => {
//     try {
//       await logout();
//     } finally {
//       navigate("/login");
//     }
//   };

//   return (
//     <header className={styles.AdminNavbarRoot_akp91}>
//       <div className={styles.AdminNavbarLeft_akp91}>
//         <button
//           type="button"
//           className={styles.AdminBurgerBtn_akp91}
//           onClick={() => setSidebarOpen((prev) => !prev)}
//           aria-label="Toggle admin sidebar"
//         >
//           <span className={styles.AdminBurgerLine_akp91} />
//         </button>

//         <div className={styles.AdminBrandWrap_akp91} onClick={() => navigate("/admin")}>
//           <div className={styles.AdminBrandLogo_akp91}>DS</div>
//           <div className={styles.AdminBrandText_akp91}>
//             <div className={styles.AdminBrandName_akp91}>DulhaSarkari Admin</div>
//             <div className={styles.AdminBrandTag_akp91}>{pageTitle}</div>
//           </div>
//         </div>
//       </div>

//       <nav className={styles.AdminTopLinks_akp91} aria-label="Admin navigation">
//         {adminLinks.map((item) => (
//           <NavLink
//             key={item.path}
//             to={item.path}
//             end={item.path === "/admin"}
//             className={({ isActive }) =>
//               `${styles.AdminTopLink_akp91} ${
//                 isActive ? styles.AdminTopLinkActive_akp91 : ""
//               }`
//             }
//           >
//             {item.label}
//             {item.badge ? <AdminNavBadge count={item.badge} /> : null}
//           </NavLink>
//         ))}
//       </nav>

//       <div className={styles.AdminNavbarRight_akp91} ref={menuRef}>
//         <div className={styles.AdminWelcomeText_akp91}>
//           <span className={styles.AdminWelcomeLabel_akp91}>Welcome,</span>
//           <strong className={styles.AdminWelcomeName_akp91}>
//             {safeText(user?.name, "Admin")}
//           </strong>
//         </div>

//         <button
//           type="button"
//           className={styles.AdminUserChip_akp91}
//           onClick={() => setMenuOpen((prev) => !prev)}
//           aria-label="Admin user menu"
//         >
//           {avatarUrl ? (
//             <img
//               src={avatarUrl}
//               alt="admin avatar"
//               className={styles.AdminUserAvatarImg_akp91}
//             />
//           ) : (
//             <span className={styles.AdminUserAvatarFallback_akp91}>
//               {safeText(user?.name, "A").charAt(0).toUpperCase()}
//             </span>
//           )}
//         </button>

//         {menuOpen && (
//           <div className={styles.AdminMenuPanel_akp91}>
//             <div className={styles.AdminMenuProfile_akp91}>
//               {avatarUrl ? (
//                 <img
//                   src={avatarUrl}
//                   alt="admin"
//                   className={styles.AdminMenuAvatarImg_akp91}
//                 />
//               ) : (
//                 <div className={styles.AdminMenuAvatarFallback_akp91}>
//                   {safeText(user?.name, "A").charAt(0).toUpperCase()}
//                 </div>
//               )}

//               <div className={styles.AdminMenuName_akp91}>
//                 {safeText(user?.name, "Admin")}
//               </div>
//               <div className={styles.AdminMenuEmail_akp91}>
//                 {safeText(user?.email, "")}
//               </div>
//               <div className={styles.AdminMenuRole_akp91}>
//                 Role: {safeText(user?.role, "admin")}
//               </div>
//             </div>

//             <div className={styles.AdminMenuActions_akp91}>
//               <button
//                 type="button"
//                 className={styles.AdminMenuBtn_akp91}
//                 onClick={() => navigate("/dashboard")}
//               >
//                 Go to User Dashboard
//               </button>

//               <button
//                 type="button"
//                 className={styles.AdminMenuDangerBtn_akp91}
//                 onClick={handleLogout}
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </header>
//   );
// }